
import { defineComponent, PropType, reactive, ref, watch } from "vue";
import Multiselect from "@/Components/General/Multiselect.vue";
import RfpCategorySelect from "./RfpCategorySelect.vue";
import RfpCategory from "@/types/Rfp/RfpCategory";
import Checkbox from "@/Components/Controls/Checkbox.vue";

export default defineComponent({
  components: {
    Checkbox,
    Multiselect,
    RfpCategorySelect
},
  props: {
    modelValue: {
      type: Object as PropType<{
        search: string;
        category_ids: number[],
        filteredBy: string;
        showClosed: boolean;
        isFilter: boolean;
      }>,
      required: true,
    },
    allCategories: {
      type: Object as PropType<RfpCategory[]>,
      required: true,
    }
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    let data = ref({
      search: props.modelValue.search ?? "",
      category_ids: [] as number[],
      filteredBy: props.modelValue.filteredBy ?? "user",
      showClosed: props.modelValue.showClosed ?? false,
      isFilter: true,
    });

    const updateFilter = () => {
      context.emit("update:modelValue", data.value);
      saveToLocalStorage();
    };

    const options = [
      {
        label: "Vis egne",
        value: "user",
      },
      {
        label: "Vis alle",
        value: "all",
      },
    ];

    const saveToLocalStorage = () => {
      localStorage.setItem("rfp.filter", JSON.stringify(data.value));
    };

    watch(
      () => data.value,
      () => {
        updateFilter();
      },
      {
        deep: true,
      }
    );

    const prevFilter = localStorage.getItem("rfp.filter");

    if (prevFilter) {
      try {
        const storageFilter = JSON.parse(prevFilter);

        if (!storageFilter.filteredBy) {
          localStorage.removeItem("rfp.filter");
        } else {
          data.value = storageFilter;
        }
      } catch (error) {
        localStorage.removeItem("rfp.filter");
      }
    }

    updateFilter();

    return {
      data,
      options,
    };
  },
});
